// extracted by mini-css-extract-plugin
module.exports =  {"gw_reviewInfo_para":"SummaryPage_gw_reviewInfo_para__N1Iiz","gwReviewInfoPara":"SummaryPage_gw_reviewInfo_para__N1Iiz"};